import { z } from 'zod';

// Folha: `mice_participants` importa daqui; `mice_invites` re-exporta.
export const MiceInviteResponseSchema = z.enum(['accepted', 'declined']);
export type MiceInviteResponse = z.infer<typeof MiceInviteResponseSchema>;
